import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d72850"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "scrollable-content",
  class: "scrollable-content"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "timeline-date__row"
}
const _hoisted_4 = {
  key: 1,
  class: "timeline-date__description"
}

import { ref, onMounted } from 'vue';
	import { rdDataComposition } from '../services';

	import Introduction from '../components/frames/introduction.vue';
	import Jul2020 from '../components/frames/jul-2020.vue';
	import Sep2020 from '../components/frames/sep-2020.vue';
	import Feb2021 from '../components/frames/feb-2021.vue';
	import Apr2021 from '../components/frames/apr-2021.vue'
	import JulAug2021 from '../components/frames/jul-aug-2021.vue';
	import Dec142021 from '../components/frames/dec-14-2021.vue';
	import Dec222021 from '../components/frames/dec-22-2021.vue';
	import Jan2022 from '../components/frames/jan-2022.vue';
	import References from '../components/frames/references.vue';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const { datum } = rdDataComposition();

	// Timeline
	const hideTimeline = ref(false);
	const toggleTimeline = () => {
		return hideTimeline.value = !hideTimeline.value;
	};
	
	const navItems = ref([
		// Add the first page.
		{ endpointId: 'introduction', hideFromTimeline: true, name: 'introduction', order: '00' },
		// Add the content navItems.
		...(datum?.value || []),
		// Add the last page.
		{ endpointId: 'references', hideFromTimeline: false, name: 'references', order: `${datum?.value?.length + 1 || '999'}0` },
	]);

	const pages = [
		Introduction,
		Jul2020,
		Sep2020,
		Feb2021,
		Apr2021,
		JulAug2021,
		Dec142021,
		Dec222021,
		Jan2022,
		References
	];

	const selectedIndex = ref(0);
	const direction = ref(1);

	const onDateSelect = (index) => {
		selectedIndex.value = index;
	};

	// Keyword events
	const onKeyDown = (event) => {
		event.preventDefault();

		if (event.key === 'ArrowUp') {
			if (selectedIndex.value > 0) {
				onDateSelect(selectedIndex.value - 1);
			}
		}

		if (event.key === 'ArrowDown') {
			if (selectedIndex.value < navItems.value.length - 1) {
				onDateSelect(selectedIndex.value + 1);
			}
		}
	};

	// Wheel events
	const onWheelScroll = (event) => {
		event.preventDefault();
		const isFirstIndex = selectedIndex?.value <= 0;
		const isLastIndex = selectedIndex?.value >= (navItems?.value?.length - 1);

		// If scrolling down and it's not the last page.
		if (event.deltaY > 0 && !isLastIndex) {
			onDateSelect(selectedIndex?.value + 1)
			direction.value = 1;
			return;
		}

		// If scrolling up and it's not the first page.
		if (event.deltaY < 0 && !isFirstIndex) {
			onDateSelect(selectedIndex?.value - 1)
			direction.value = -1;
		}
	}

	// Touch events
	const startY = ref(0);
	const endY = ref(0);
	const threshold = ref(40);

	const initTouch = (event) => {
		if (event.srcElement.localName !== 'a') {
			event.preventDefault();
		}
		startY.value = event.changedTouches[0] ? event.changedTouches[0].screenY : 0;
	}
	
	const endTouch = (event) => {
		if (event.srcElement.localName !== 'a') {
			event.preventDefault();
		}
		endY.value = event.changedTouches[0] ? event.changedTouches[0].screenY : 1;

		evaluateTouch();
	}

	const evaluateTouch = () => {
		const isFirstIndex = selectedIndex?.value <= 0;
		const isLastIndex = selectedIndex?.value >= (navItems?.value?.length - 1);

		if (endY.value > startY.value && endY.value - startY.value > threshold.value && !isFirstIndex) {
			onDateSelect(selectedIndex?.value - 1);
			direction.value = -1;
		} else if (startY.value > endY.value && startY.value - endY.value > threshold.value && !isLastIndex) {
			onDateSelect(selectedIndex?.value + 1);
			direction.value = 1;
		}
	}

	// Evaluate events
	onMounted(() => {
		document.addEventListener('keydown', onKeyDown);
		document.getElementById('scrollable-content')?.addEventListener?.('wheel', onWheelScroll);
		document.getElementById('scrollable-content')?.addEventListener?.('touchstart', initTouch);
		document.getElementById('scrollable-content')?.addEventListener?.('touchend', endTouch);
	})

return (_ctx: any,_cache: any) => {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["content", { expand: hideTimeline.value === true }])
    }, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleTimeline())),
        class: "content__toggle crux-click",
        "data-crux": "timeline-toggle"
      }, [
        _createVNode(_component_base_image_svg, {
          source: require(`@/applications/covid-hub/ui/assets/icons/burger.png`),
          "is-image": true
        }, null, 8, ["source"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: direction.value === 1 ? 'fade-up' : 'fade-down'
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(pages[selectedIndex.value]), { isActive: true }))
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["timeline", { hidden: hideTimeline.value === true }])
    }, [
      _createElementVNode("div", {
        class: "timeline__toggle crux-click",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleTimeline())),
        "data-crux": "timeline-toggle"
      }, [
        _createVNode(_component_base_image_svg, {
          class: "arrow-down",
          source: require(`@/applications/covid-hub/ui/assets/icons/burger.png`),
          "is-image": true
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "timeline__description",
          "asset-key": "timeline-description"
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (navItem, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: navItem.order,
          class: "timeline-date__details crux-click",
          onClick: ($event: any) => (onDateSelect(index)),
          "data-crux": "timeline-date"
        }, [
          (!navItem.hideFromTimeline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (index > selectedIndex.value)
                  ? (_openBlock(), _createBlock(_component_base_image_svg, {
                      key: 0,
                      class: "empty",
                      source: require(`@/applications/covid-hub/ui/assets/images/circle-empty.png`),
                      "is-image": true
                    }, null, 8, ["source"]))
                  : _createCommentVNode("", true),
                (index <= selectedIndex.value)
                  ? (_openBlock(), _createBlock(_component_base_image_svg, {
                      key: 1,
                      class: _normalizeClass(["filled", { large: index === selectedIndex.value }]),
                      source: require(`@/applications/covid-hub/ui/assets/images/circle-filled.png`),
                      "is-image": true
                    }, null, 8, ["class", "source"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_lyra_asset, {
                  class: _normalizeClass(["timeline-date", { large: index === selectedIndex.value }]),
                  "asset-key": `rd-frame-${navItem.endpointId}`
                }, null, 8, ["class", "asset-key"])
              ]))
            : _createCommentVNode("", true),
          (!navItem.hideFromTimeline && navItem.name !== 'references')
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _createVNode(_component_lyra_asset, {
                  "asset-key": `rd-timeline-copy-${navItem.endpointId}`
                }, null, 8, ["asset-key"])
              ]))
            : _createCommentVNode("", true),
          (!navItem.hideFromTimeline)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["timeline-date__line", { isBlue: index < selectedIndex.value }])
              }, null, 2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      }), 128)),
      _createVNode(_component_base_image_svg, {
        class: "timeline-date__logo",
        "is-image": true,
        source: require(`@/applications/covid-hub/ui/assets/images/pfizer-medical-logo.png`)
      }, null, 8, ["source"])
    ], 2)
  ], 64))
}
}

})